export default (state = false, { type, payload }) => {
  switch (type) {
    case 'OPEN_ASSIGN_SUBSCRIPTION':
      return true
    case 'CLOSE_ASSIGN_SUBSCRIPTION':
      return false
    default:
      return state
  }
}